import React from 'react';

import {assert} from 'Asserts';
import {pluralize} from 'BenchlingUtil';
import Link from 'ui-library/Link';

import {ErrorMessage, ErrorMessages} from '../../BulkWorkflowComponents';
import {LocalAssembly, Summary} from '../BulkAssemblyConstants';
import * as BulkAssemblyUtil from '../BulkAssemblyUtil';
import ValidationStatus from './ValidationStatus';

interface AssemblySummaryProps {
  assembly: LocalAssembly;
  onOpenPrimerSettings: () => void;
}

function getSummaryText(assembly: LocalAssembly, summary: Summary): string {
  if (BulkAssemblyUtil.isGibsonAssembly(assembly) && summary.numPrimerPairs) {
    return `${summary.numOutputSequences} ${pluralize(summary.numOutputSequences, 'sequence')} and ${
      summary.numPrimerPairs
    } primer ${pluralize(summary.numPrimerPairs, 'pair')} will be created.`;
  } else {
    assert(
      !BulkAssemblyUtil.isGibsonAssembly(assembly),
      'Expected to receive the number of primer pairs in a Gibson assembly.'
    );
    return `${summary.numOutputSequences} ${pluralize(
      summary.numOutputSequences,
      'sequence'
    )} will be created.`;
  }
}

export default function AssemblySummary({assembly, onOpenPrimerSettings}: AssemblySummaryProps): JSX.Element {
  const errors = [...new Set(BulkAssemblyUtil.getErrors(assembly))];
  const gibsonErrorSlots = BulkAssemblyUtil.slotsWithGibsonPrimerErrors(assembly);
  return (
    <div>
      {errors.length > 0 && (
        <ErrorMessages>
          {errors.map((error, i) => (
            <ErrorMessage key={i}>{error}</ErrorMessage>
          ))}
        </ErrorMessages>
      )}
      <ValidationStatus assembly={assembly} />
      {BulkAssemblyUtil.isGibsonAssembly(assembly) && gibsonErrorSlots.length > 0 ? (
        <ErrorMessage>
          {`No Gibson primers could be found for ${gibsonErrorSlots
            .map((i) => assembly.slots[i].slotParams.name)
            .join(', ')}. Try adjusting your `}
          <Link onClick={onOpenPrimerSettings}>primer settings</Link>.
        </ErrorMessage>
      ) : (
        errors.length === 0 &&
        assembly.meta.summary && <div>{getSummaryText(assembly, assembly.meta.summary)}</div>
      )}
    </div>
  );
}
